const enUS = {
  nav: {
    customerSuccess: 'Customer Success',
    solutions: 'Solutions',
    partnerEcosystem: 'Partner Ecosystem',
    contactUs: 'Contact Us',
    login: 'Login',
  },
  solutions: {
    smartLaborPerformance: 'Smart Labor Performance',
    yieldIntelligence: 'Yield Intelligence',
    harvestManagement: 'Harvest Management',
  },
  home: {
    heroTitle: 'Explore The Infinite Possibility Of Agriculture',
    heroDesc:
      'Integrated labor management, precision harvests, and professional cultivation solutions for greenhouses and smallholder farms worldwide.',
    heroCTA: 'Our Solutions',
    impactTitle: 'COSMOS Impact',
    impactDesc:
      'Our digital farm solutions spread across multiple regions, covering farmland and packhouse facilities while filling cultivation gaps.',
    stats: {
      farmValue: '3,500 Ha',
      farmLabel: 'Farm Operations Digitized',
      warehouseValue: '30,000 m³',
      warehouseLabel: 'Packhouse Areas Digitized',
      countriesValue: '5',
      countriesLabel: 'Countries Served',
      cropsValue: '20+',
      cropsLabel: 'Crop Categories Supported',
      devicesValue: '2000+',
      devicesLabel: 'Active Smart Connected Devices',
      ceaValue: '100 Ha',
      ceaLabel: 'CEA Under Management',
      recordsValue: '30 Million+',
      recordsLabel: 'Operational Records Captured',
      produceValue: '1 Million+',
      produceLabel: 'Tons Of Fresh Produce Digitally Tracked',
      leadersValue: '10+',
      leadersLabel: 'Global Leaders in Fresh Produce',
      leadersDesc: 'Leading growers, marketers and produce companies worldwide',
      researchValue: '3',
      researchLabel: 'Research & Innovation Projects Contributed to',
      researchDesc: 'Bridging industry and academia',
      jobsValue: '15000+',
      jobsLabel: 'Rural Jobs Supported',
      jobsDesc: 'Enabling economic opportunities across agricultural communities',
    },
    trustedBy: 'Trusted By',
    trustedByDesc:
      'We build long-term partnerships with world-class agricultural brands, deepen industry-university innovation cooperation, and fuel local rural economy by generating stable employment opportunities in farming regions globally.',
    successTitle: 'Grow With Our Success',
    cases: {
      Haygrove: 'Haygrove',
      BERRIESBLUE: 'BERRIESBLUE',
      Driscoll: 'Driscoll\'s',
      cherryTitle: 'Digital Management for Cherry & Blueberry Farms',
      packhouseTag: 'WEBINAR',
      packhouseTitle: 'Full-chain Digitization of Blueberry Packhouse',
      packhouseDesc:
        'We have established in-depth cooperation with many well-known enterprises and use COSMOS to fully digitize the entire process — from cultivation and warehousing to logistics — achieving full-chain digital management.',
      harvestTag: 'Berries',
      harvestTitle: 'Smart Harvest System for Multiple Berry Crops',
      protectedTag: 'Crop',
      protectedTitle: 'Blueberry & Cherry Protected Cultivation Project',
    },
  },
  slp: {
    heroTag: 'Smart Labor Performance',
    heroTitle: 'See the work. Improve results.',
    heroDesc:
      'Gain real-time visibility into workforce activities, verify field execution, and automate labor records. Ensure the right work happens at the right place and time while improving productivity, accountability, and operational performance.',
    workforceTitle: 'Workforce Visibility',
    workforceDesc:
      'Know where your teams are and how work is progressing in real time through NFC check-ins, GPS positioning technology, and COSMOS smart wearables.',
    executionTag: 'NFC + GPS / UWB',
    executionTitle: 'Execution Assurance',
    executionDesc:
      'Verify who performed what work, where, and when. NFC, GPS-based verification, and COSMOS Labor WearableOS create a digital record of field execution and help ensure critical tasks are completed as planned.',
    insightsTag: 'AI Assistant',
    insightsTitle: 'Performance Insights',
    insightsDesc:
      'Automatically measure productivity, attendance, utilization, and task completion through the COSMOS Labor Performance Portal, transforming workforce data into operational insights.',
    testimonial1:
      'As labor managers, this tool enables us to monitor work progress and staff status in real time. Automated management drastically boosts our overall operational efficiency.',
    testimonial2:
      "This labor management system has greatly optimized our daily work. Staff scheduling, harvest tracking and attendance management are all done efficiently in one platform. It's a real time-saver for our team.",
    workflowsTitle: 'Designed for Agricultural Workflows',
    workflowsDesc:
      'Manage task assignments, job selection, scheduling, attendance, and performance through the combination of wearable and digital platform designed specifically for agricultural operations.',
    workflow1Desc:
      'Schedule shifts on PC and publish to worker wearable with one click.',
    workflow2Desc:
      'After receiving shift information, workers select job type and clock in via the wearable.',
    workflow3Desc:
      'Automatic wage calculation and notification based on attendance records and performance data.',
  },
  yi: {
    heroTag: 'Yield Intelligence',
    heroTitle: 'Predict Production. Plan With Confidence.',
    heroDesc:
      'Turn crop observations, biological models, and AI into actionable yield forecasts that improve harvest planning, labor allocation, packing operations, and sales decisions.',
    cropScienceTitle: 'Crop Science Meets AI',
    cropScienceDesc:
      'Mapping crop growth models combined with real farm data deliver forecasts that are explainable, transparent, and grounded in crop biology — not black-box algorithms.',
    forecastsTitle: 'Turn Forecasts Into Actions',
    forecastsDesc:
      'Yield forecasts are seamlessly connected to operational workflows, enabling teams to plan labor, harvest schedules, packing capacity, and sales commitments directly within COSMOS Yield Intelligence Portal.',
    dataCollectionTitle: 'Practical Data Collection, Designed For Return-On-Investment',
    dataCollectionDesc:
      'Forecast accuracy starts with the right data. COSMOS designs and deploys AI-driven plant data collection solutions — from computer vision and mobile scouting to sensors and automation — tailored to each crop and production environment.',
  },
  hm: {
    heroTag: 'Harvest Management',
    heroTitle: 'From Branch to Table, Every Berry Traceable',
    heroDesc:
      'From open-field orchards to protected cultivation, we deliver digital solutions for diverse crop scenarios — one-click harvest traceability, full cold-chain visibility in transit, precision crop protection down to the individual plant, and automated irrigation and fertigation on demand.',
    efficiencyTitle: 'High Efficiency',
    efficiencyDesc:
      'High-speed harvest recording and instant worker identification are powered by RFID-enabled bulk weighing, dramatically reducing processing time. The system supports all types of RFID tags and containers, enabling flexible matching for any workflow.',
    traceabilityTitle: 'End-to-End Traceability',
    traceabilityDesc:
      'Track every harvest lot from field to shipment, sync data from field to dashboard in seconds, and continuously measure workforce performance with full-chain visibility.',
    traceabilityPoints: [
      'Track every harvest lot from field to shipment.',
      'From field to dashboard in seconds.',
      'Measure and improve workforce performance.',
    ],
    traceabilityImageAlt: 'Harvesting Summary',
  },
  comingSoon: {
    title: 'Coming Soon',
    desc: 'This page is under construction. Stay tuned!',
    back: 'Back to Home',
  },
  footer: {
    copyright: 'Copyright © COSMOS',
    contactEmail: 'Shaun.he@cosmos.ag',
    contactVia: 'Contact via',
    customerSuccessTitle: 'Customer Success',
    solutionsTitle: 'Solutions',
    partnerTitle: 'Partner Ecosystem',
    contactTitle: 'Contact',
    partnerHero: 'Hero',
    partnerWhy: 'Why Partner With COSMOS',
    partnerOpportunities: 'Partnership Opportunities',
  },
}

export default enUS
